import { useState, useEffect } from "react";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { useParams } from "react-router-dom";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const path = '/propertyterms/';
    const paths = {
        endpointSave: config.endpoints.backend + 'propertyterms/save',
        endpointGetById: config.endpoints.backend + 'propertyterms/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Termo de Uso",
        labelTitleEdit: "Editar Termo de Uso",
        labelTitleView: 'Visualizar Termo de Uso'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    // extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
